<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            MÚSICA ANDINA, MESTIZA<br>
            Y CRIOLLA EN LOS<br>
            COMPOSITORES ACADÉMICOS<br>
            <span class="fontMS300">(1900-1950)</span><br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio2/compositores">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio2/compositores">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio2/compositores">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    <br>
                    LA MÚSICA ES UN ARTE Y, A LA VEZ, UN MEDIO DE EXPRESIÓN QUE NOS ENRIQUECE INDIVIDUAL Y COLECTIVAMENTE. NUESTRA SOCIEDAD ES DIVERSA ÉTNICA, 
                    CULTURAL Y LINGÜÍSTICAMENTE, NUESTRAS HERENCIAS CULTURALES SON MÚLTIPLES, Y SE EXPRESAN EN UNA VARIEDAD DE MANIFESTACIONES MUSICALES.
                </p>
                <p class="fontMS100 text-justify font-24">
                    Estas son derivadas de un proceso de incorporación y préstamos de elementos que podemos documentar desde el antiguo Perú hasta la irrupción 
                    de formas musicales e instrumentos europeos durante la etapa colonial, a las que se incorpora el aporte africano. Este “mestizaje” tiene como 
                    denominador común la estrecha relación de la música con la vida familiar y comunal, las costumbres y la religiosidad.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-38">
                            LA COLECCIÓN DE PARTITURAS
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 2%;"
                    class="fontMS700 text-center colorPrincipal font-38">
                    RODOLFO HOLZMANN
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            <br><br><br>
                            LA BIBLIOTECA NACIONAL DEL PERÚ PRESERVA LA COLECCIÓN DE PARTITURAS DEL MÚSICO ALEMÁN RODOLFO HOLZMANN (1910-1992): 
                            COMPOSITOR, DOCENTE Y ARREGLISTA DE MÚSICA SINFÓNICA. LLEGÓ AL PERÚ EN 1938 COMO PROFESOR DE OBOE DE LA ACADEMIA NACIONAL 
                            DE MÚSICA ALCEDO, QUE LUEGO SE CONVERTIRÍA EN EL CONSERVATORIO NACIONAL A PARTIR DE 1946 Y, POSTERIORMENTE, EN LA UNIVERSIDAD 
                            NACIONAL DE MÚSICA.
                            <br><br><br>
                        </p>
                        <div class="col-sm-12 libro text-right">
                            <a href="http://hdl.handle.net/20.500.14428/79087" target="_blank" style="color: black;">
                                <img width="70%" class="img-fluid imgNP"
                                    src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img002.jpg">
                                <div class="overlay4">
                                    <p class="fontMS500 text-center">
                                        Pequeña suite para piano: <br>
                                        estilizaciones sobre motivos <br>
                                        del folklore del Perú <br>
                                        <span class="fontMS100">1944</span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-justify font-24">
                            <br><br><br>
                            A través de esta institución, en la que pasa a enseñar composición, Holzmann influyó en la formación de una generación de jóvenes compositores, 
                            quienes desarrollarán la nueva música académica peruana. Como investigador, se interesó en las danzas y las canciones tradicionales y realizó una 
                            sostenida recopilación de música escrita en diversos géneros: valses, yaravíes, huaynos, himnos y marineras en su mayoría de autores limeños, cusqueños 
                            y arequipeños. Esta colección es notable para la investigación del desarrollo de géneros y estilos musicales, así como su distribución y consumo.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 120%;margin-bottom: 0%;" class="fontMS500 font-40 colorPrincipal">
                            REBAGLIATI:
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-top: 0%;" class="fontMS300 colorPrincipal font-40">
                    PRECURSOR DEL ENCUENTRO<br>
                    ENTRE LA TRADICIÓN POPULAR<br>
                    Y LA MÚSICA ACADÉMICA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                </div>
                <div class="row">
                    <div class="col-sm-1">
                        <br>
                    </div>
                    <div class="col-sm-10 mt-3 mb-3">
                        <p class=" fontMS500 text-white font-24">
                            A MEDIADOS DEL SIGLO XIX LA MÚSICA ACADÉMICA EN LA CIUDAD DE LIMA SE TRASMITIÓ A TRAVÉS MONASTERIOS, MEDIANTE 
                            LA ENSEÑANZA PRIVADA, LA PRESENCIA DE MÚSICOS EXTRANJEROS Y POR REPRESENTACIONES DE OBRAS QUE SEGUÍAN LOS ESTILOS, 
                            MODELOS E INFLUENCIAS EUROPEAS EN TEATROS Y SALONES.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1">
                        <br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <p class="fontMS100 text-white font-24">
                            El compositor y violinista italiano Claudio Rebagliati Ricaldone tiene un lugar destacado en 
                            la historia de la música peruana por la restauración, armonización e instrumentación, en 1869, 
                            del Himno Nacional, a solicitud de su autor Bernardo Alzedo. Un año antes, Rebagliati compone 
                            <span class="fontMS100Italic">Un 28 de julio. Rapsodia peruana para orquesta</span>,
                            antecedente directo del nacionalismo musical de fines del siglo XIX. Es una de las primeras 
                            obras sinfónicas compuestas en el Perú, y también es precursora en el estilo de combinar motivos 
                            de canciones y marchas populares con sonoridades de la cashua andina y el yaraví. Estas se fusionan 
                            en la composición con variaciones de la melodía del Himno Nacional, convirtiendo la conmemoración de 
                            nuestra independencia, aludida en el título, en todo un símbolo de la promesa republicana peruana: 
                            una nación de ciudadanos diversos unidos e iguales.
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <br><br>
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="text-white font-24 ml-5">
                                    <span class="fontMS700 font-24">
                                        <br>
                                        Claudio Rebagliati<br>
                                        (Noli, 1843 - Lima, 1909) <br>
                                    </span>
                                    Fotografía por Eugenio Courret, 1885
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/35986" target="_blank" style="color: black;">
                                    <p class="text-center font-24">
                                        <img width="100%"
                                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img003a.jpg">
                                    </p>
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="text-white font-24 ml-5">
                                    <span class="fontMS700 font-24">
                                        <br>
                                        Un 28 de julio. Rapsodia <br>
                                        peruana para gran <br>
                                        orquesta <br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/65688" target="_blank" style="color: black;">
                                    <p class="text-center font-24">
                                        <img width="100%"
                                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img003b.jpg">
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <p>
                    <br><br><br>
                    <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                    <br><br><br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6 text-center">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 font-40 colorPrincipal">
                            EL NACIONALISMO MUSICAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS300 text-center colorPrincipal font-40">
                    LA HERENCIA ANDINA,<br>
                    MESTIZA Y CRIOLLA<br>
                    EN LA COMPOSICIÓN ACADÉMICA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                </div>
                <p class="fontMS500 text-center text-white font-24">
                    <br>
                    A INICIOS DE SIGLO XX, LA INTELECTUALIDAD PERUANA EMPIEZA A GENERAR EN LA SOCIEDAD UN INTERÉS POR LOS PUEBLOS 
                    INDÍGENAS DEL PAÍS, SU CULTURA Y TRADICIONES. ES A TRAVÉS DE LAS INVESTIGACIONES SOBRE EL PASADO PREHISPÁNICO,
                    QUE SE DIFUNDE UNA VISIÓN IDEALIZADA SOBRE EL IMPERIO INCAICO.
                </p>
                <p class="text-white text-justify font-24">
                    <br>
                    Es a través de este modo, que se busca una nueva identidad nacional basada en las culturas indígenas andinas. 
                    La producción literaria y artística se renovó técnica y formalmente y fueron importantes vehículos para su difusión. 
                    A este movimiento se le denominó indigenismo.

                    Durante la década de 1920, la corriente indigenista peruana es utilizada políticamente por el Estado, que adopta la 
                    identidad “inca” como parte de la retórica oficial para validarse.
                    <br><br>
                    El indigenismo influyó en los compositores de música académica peruana, quienes adoptan melodías y ritmos andinos en 
                    la estructura de sus obras, además de la pentafonía, configurando una orientación “nacionalista” musical que alcanza 
                    altos niveles de complejidad creativa y de innovación. El “nacionalismo musical” se desarrolló principalmente en las 
                    ciudades de Arequipa, Cusco, Huánuco, Lima, Trujillo y Puno, en simultáneo con la amplia difusión del disco y el consumo 
                    de géneros musicales foráneos.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span class="fontMS100">{{slide.anuNacimiento}}</span><br>
                                <span class="fontMS100">{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="text-white text-justify font-24">
                    <span class="fontMS500">Theodoro Valcárcel Caballero (Puno, 1896 - Lima, 1942) </span> es uno de los más destacados 
                    compositores de música académica, y ha sido considerado como el iniciador del modernismo musical en nuestro país. 
                    Exploró las posibilidades de la música tradicional en sus composiciones para orquesta, violín y piano, incluso escribió 
                    canciones con textos en lenguas originarias como el quechua, aimara y huitoto.
                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <a target="_blank" class="enlace" href="https://hdl.handle.net/20.500.14428/42521" style="color: inherit;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004n.jpg">
                        </a>
                        <p class="fontMS100Italic text-white">
                            Theodoro Valcárcel Caballero Tâhwa inka'j tak'y-nam, cuatro canciones inkaicas 1930
                        </p>


                    </div>
                    <div class="col-sm-8">

                        <a target="_blank" class="enlace" href="https://hdl.handle.net/20.500.14428/29153" style="color: inherit;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_img004n2.jpg">
                        </a>

                        <p class="fontMS100Italic text-white">
                            Theodoro Valcárcel Caballero (tercero a la derecha).
                            Fotografía de Adolphe Dubreuil Ca. 1913
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-22">
                    <br>
                    PARA EL INVESTIGADOR BRINDAN VARIAS INFORMACIONES QUE VAN MÁS ALLÁ DE LO PROPIAMENTE MUSICAL
                    INSCRITO EN EL PENTAGRAMA. LA ICONOGRAFÍA QUE ILUSTRA LO MUSICAL, LAS DEDICATORIAS, EL NOMBRE
                    DEL AUTOR, LA CASA EDITORIAL Y SU DIRECCIÓN, LA CASA DE LITOGRAFÍA QUE REALIZÓ EL DIBUJO, LA
                    FECHA DE APARICIÓN Y PUBLICIDADES IMPRESAS EN LA CONTRACARÁTULA SON ELEMENTOS QUE CONFLUYEN PARA
                    HACER DE LA PARTITURA UNA FUENTE DE GRAN INTERÉS.
                    <br>
                </p>
                <p class="text-right fontMS500Italic font-22">
                    <span>
                        GÉRARD BORRAS, 2015.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            LAS ESCUELAS REGIONALES
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS700 font-40">
                    <br>
                    AREQUIPA
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-1">
                        <br>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-justify font-24 fontMS500">
                            <br>
                            HACIA FINALES DEL SIGLO XIX, LA CIUDAD DE AREQUIPA EMPEZÓ A CONSOLIDAR SU INDUSTRIA EN EL SECTOR LANAR, 
                            AUGE QUE SE MANTUVO HASTA FINALES DE LA DÉCADA DE 1920. LA SOSTENIDA ACTIVIDAD COMERCIAL SUMADA A LA 
                            EXPANSIÓN URBANA Y VIAL TUVO COMO PARALELO UNA INTENSA ACTIVIDAD CULTURAL QUE SE MANIFESTÓ EN PUESTAS 
                            ESCÉNICAS O VELADAS LITERARIAS Y MUSICALES.
                            <br><br>
                        </p>
                    </div>
                </div>
                <p class="font-24 text-justify">
                    La música popular y de salón era muy extendida entre la sociedad arequipeña, con una presencia importante de agrupaciones
                     y sociedades musicales. Sonoridades del yaraví, huaynos y mulizas compartían espacios con las actividades operísticas. 
                     Las nuevas inquietudes intelectuales y la revalorización de las tradiciones rurales originan en los compositores de música
                      académica una tendencia hacia la temática vernacular, muchas veces denominada “incaica”, donde resalta la escala pentafónica
                       y sus derivaciones.
                    <br><br>
                    Diferentes géneros musicales podían escucharse en la ciudad, populares, tradicionales y
                    contemporáneos extranjeros produciendo formas híbridas, desde el <span
                        class="fontMS100Italic">swing</span> incaico hasta el vals. De
                    este modo, una nueva generación de compositores arequipeños desarrolla en su música un carácter
                    propio y regional.
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides2" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span>{{slide.anuNacimiento}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS700 font-40">
                            CUSCO
                        </p>
                        <div class="row">
                            <div class="col-sm-1">
                                <br>
                            </div>
                            <div class="col-sm-11">
                                <p class="text-justify font-24 fontMS500">
                                    <br>
                                    A INICIOS DEL SIGLO XX, LA CIUDAD DEL CUSCO MANTENÍA SU AUTONOMÍA ECONÓMICA DE LA CAPITAL LIMA, Y 
                                    PARALELAMENTE REGISTRABA UNA GRAN ACTIVIDAD CULTURAL. EN EL IMAGINARIO NACIONAL E INTERNACIONAL, 
                                    LOS INTELECTUALES CUSQUEÑOS PLANTEABAN QUE EL LEGADO CULTURAL INDÍGENA ANDINO REPRESENTABA EL UMBRAL 
                                    DE LA “IDENTIDAD PERUANA”.
                                    <br><br>
                                </p>
                            </div>
                        </div>
                        <p class="font-24 text-justify">
                            Las primeras investigaciones musicales sobre melodías tradicionales y regionales se convirtieron en insumo para 
                            los compositores académicos quienes introdujeron este material a sus composiciones de estilo occidental, incorporando 
                            escalas pentafónicas y melodías andinas que se vinculan con la historia prehispánica. Muchas de las obras son tituladas 
                            en quechua.
                            <br><br>
                            La consolidación de esta expresión cultural se reafirma con la aparición de extraordinarios compositores que guían el 
                            desarrollo musical cusqueño. Su expansión se debió a las variadas instituciones, conjuntos y elencos que organizaban 
                            exitosas giras, acompañadas de teatro, música y danzas por las principales ciudades del Perú, y países como Argentina, 
                            Bolivia y Uruguay.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides3" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <!-- <a style="color: inherit;" [routerLink]="['/visor',slide.id]" target="_blank"> -->
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span>{{slide.anuNacimiento}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="font-24 text-justify">
                    <span class="fontMS500">Francisco González Gamarra (Cusco, 1890 – Lima, 1974)</span> fue, además de pintor 
                    y caricaturista, investigador y compositor musical. Su vocación y sensibilidad artística lo convirtieron en 
                    un artista singular. Musicalmente exploró arreglos y composiciones inspirados en el folklore nacional. Además, 
                    fue ilustrador en el semanario <span class="fontMS100Italic">Variedades</span>, pintando destacadas obras de temas 
                    históricos, por lo que tuvo múltiples reconocimientos por su aporte a la cultura peruana.
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides4" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <a style="color: inherit;">
                        <!-- <a style="color: inherit;" [routerLink]="['/visor',slide.id]" target="_blank"> -->
                        <p class="text-center">
                            <img src="{{ slide.img }}" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span>{{slide.descrpcion}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>

<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Desde fines del siglo XIX hasta el primer tercio del siglo XX, las partituras circulaban
                            extensamente. En el presente se tornan en documentos culturales que nos muestran los
                            diversos géneros musicales, tanto populares como académicos, que eran más difundidos. Tener
                            una partitura implicaba saber leer música y contar con un piano para su ejecución, por lo
                            cual solo podía acceder un sector social acomodado. Sin embargo, la música se hizo masiva a
                            través del gramófono y de la radio, transformando gustos y valores musicales.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿La educación y comprensión del lenguaje musical está extendida hoy? ¿Cuál
                            sería su importancia?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Escuchemos <span class="fontMS500Italic">Chililin-Uth´aja</span> o "Campanita de mi pueblo"
                            de Theodoro Válcarcel. <br>
                            ¿Qué sensaciones te produce esta canción?
                        </p>

                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <audio controls controlsList="nodownload">
                            <source src="\assets\audios\Chililin Utaja.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>

                    </div>
                    <!-- <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24"> 
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 80%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br>
                </p>
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Bolaños, C., Estenssoro, J., Iturriaga, E., Quezada, J., Pinilla, E. y Romero, R.
                                (2007).
                            </span><br>
                            <span class="fontMS100Italic text-gris">
                                La Música en el Perú.</span>
                            <span class="text-gris">
                                Lima: Fondo Editorial Filarmonía.
                            </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=342695" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Lloréns Amico, J. (1983).
                            </span><br>
                            <span class="fontMS100Italic text-gris">
                                Música popular en Lima: criollos y andinos. <br>
                            </span>
                            <span class="text-gris">
                                Lima: Instituto de Estudios Peruanos. <br>
                            </span>
                            <a href="https://repositorio.iep.org.pe/bitstream/IEP/576/2/llorens_musicapopularenlima.pdf"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Sánchez Málaga, A. (2012).<br>
                            </span>
                            <span class="fontMS100Italic text-gris">
                                Nuestros otros ritmos y sonidos: la música clásica en el Perú.
                            </span>
                            <span class="text-gris">
                                Lima: Fondo Editorial del Congreso del Perú.<br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=489383" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Sulca Flores, S. (2017).<br>
                            </span>
                            <span class="fontMS100Italic text-gris">
                                El valor cultural de las partituras de la Colección Rodolfo Holzmann de la Biblioteca
                                Nacional del Perú<br>
                            </span>
                            <span class="text-gris">
                                Lima:
                                Universidad Nacional Mayor de San Marcos. <br>
                            </span>
                            <a href="https://cybertesis.unmsm.edu.pe/bitstream/handle/20.500.12672/7277/Sulca_fs.pdf?sequence=1"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Pinilla, E. (1980).
                            </span><br>
                            <span class="fontMS100Italic text-gris">
                                Informe sobre la música en el Perú. En: Historia del Perú
                            </span>
                            <span class="text-gris">
                                Tomo IX. Lima: Editorial Juan Mejía Baca.
                            </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=227137" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Raygada, C. (1956-1957, 1963, 1964).
                            </span><br>
                            <span class="fontMS100Italic text-gris">
                                Guía Musical del Perú.
                            </span>
                            <span class="text-gris">
                                En: Fénix Revista de la Biblioteca Nacional (N°12, 13 y 14). Lima.
                            </span><br>
                            <a href="http://revistafenix.bnp.gob.pe/index.php/fenix/issue/archive/2" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Romero, R. (2015).
                            </span><br>
                            <span class="fontMS100Italic text-gris">
                                Música popular y sociedad en el Perú contemporáneo.
                            </span>
                            <span class="text-gris">
                                Lima: Pontificia Universidad Católica del Perú.
                            </span><br>
                            <a href="http://repositorio.pucp.edu.pe/index/bitstream/handle/123456789/134538/Libro%20-%20Musica%20Popular%20y%20Sociedad%20en%20el%20Peru.pdf?sequence=1&isAllowed=y"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->